import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ accountConcurrentLabels: 'concurrentLabels/getConcurrentLabels' }),
    savedConcurrentLabels() {
      return this.$store.getters[
        'conversationConcurrentLabels/getConversationConcurrentLabels'
      ](this.conversationId);
    },
    activeConcurrentLabels() {
      return this.accountConcurrentLabels.filter(({ title }) =>
        this.savedConcurrentLabels.includes(title)
      );
    },
    inactiveConcurrentLabels() {
      return this.accountConcurrentLabels.filter(
        ({ title }) => !this.savedConcurrentLabels.includes(title)
      );
    },
  },
  methods: {
    addConcurrentLabelToConversation(value) {
      const result = this.activeConcurrentLabels.map(item => item.title);
      result.push(value.title);
      this.onUpdateConcurrentLabels(result);
    },
    removeConcurrentLabelFromConversation(value) {
      const result = this.activeConcurrentLabels
        .map(concurrent => concurrent.title)
        .filter(concurrent => concurrent !== value);
      this.onUpdateConcurrentLabels(result);
    },
    async onUpdateConcurrentLabels(selectedConcurrentLabels) {
      this.$store.dispatch('conversationConcurrentLabels/update', {
        conversationId: this.conversationId,
        concurrentLabels: selectedConcurrentLabels,
      });
    },
  },
};

